import { useEffect, useState } from 'react';
import {
  COLOR_GROUPS,
  PRIMARY_SHADE_STEPS,
  ColorToken
} from './colors.data.ts';

interface RuntimeShade {
  name: string;
  value: string;
}

const ColorSwatch = ({ token }: { token: ColorToken }) => (
  <div className="w-[112px] rounded-lg border border-gray-200 overflow-hidden bg-white shadow-sm">
    <div
      className="h-11 w-full"
      style={{ background: `var(--${token.name})` }}
    />
    <div className="px-2 py-1.5">
      <p
        className="text-xs font-medium text-gray-800 truncate"
        title={token.name}
      >
        {token.name}
      </p>
      <p className="text-[10px] text-gray-400 truncate" title={token.value}>
        {token.value}
      </p>
    </div>
  </div>
);

function ColorsComponent() {
  const [primaryShades, setPrimaryShades] = useState<RuntimeShade[]>([]);

  useEffect(() => {
    const rootStyle = getComputedStyle(document.documentElement);
    const shades = PRIMARY_SHADE_STEPS.map((step) => {
      const name = `primary-${step}`;
      return {
        name,
        value: rootStyle.getPropertyValue(`--${name}`).trim() || '—'
      };
    });
    setPrimaryShades(shades);
  }, []);

  return (
    <div className="flex flex-col gap-10">
      <h2 className="text-xl font-bold text-gray-800">Colors</h2>

      {COLOR_GROUPS.map((group) => (
        <div
          key={group.title}
          className="flex flex-col gap-4 lg:flex-row lg:items-start lg:gap-8 border-b pb-8 last:border-none"
        >
          <div className="w-[120px] shrink-0">
            <p className="text-sm font-bold uppercase tracking-wide text-gray-500">
              {group.title}
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            {group.tokens.map((token) => (
              <ColorSwatch key={token.name} token={token} />
            ))}
          </div>
        </div>
      ))}

      {/* Runtime-generated primary shades (DynamicThemeProvider) */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:gap-8">
        <div className="w-[120px] shrink-0">
          <p className="text-sm font-bold uppercase tracking-wide text-gray-500">
            Primary shades
          </p>
          <p className="mt-1 text-xs text-gray-400">
            Runtime (depends on organization branding)
          </p>
        </div>
        <div className="flex flex-wrap gap-3">
          {primaryShades.map((shade) => (
            <ColorSwatch key={shade.name} token={shade} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ColorsComponent;
